import React, { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { YPageShellSegmentedTabs } from '../../../ui/shell';
import {
  COMMUNITY_SHELL_TABS,
  parseCommunityTab,
  communityPathForTab,
} from '../constants/communityRoutes';
import './community-shell.css';

/**
 * Shared Community shell tabs (5c). Mount at the top of each community pane.
 */
export function CommunityShellTabs() {
  const navigate = useNavigate();
  const location = useLocation();
  const activeId = parseCommunityTab(location.pathname);

  const handleTabChange = useCallback(
    (tabId) => {
      const nextPath = communityPathForTab(tabId);
      if (nextPath === location.pathname) return;
      navigate(nextPath);
    },
    [navigate, location.pathname]
  );

  return (
    <div className="community-shell__tabs" data-testid="community-shell-tabs">
      <YPageShellSegmentedTabs
        tabs={COMMUNITY_SHELL_TABS}
        activeId={activeId}
        onTabChange={handleTabChange}
        ariaLabel="Community sections"
      />
      <span className="visually-hidden" data-testid="community-active-tab">
        {activeId}
      </span>
    </div>
  );
}
